import { Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black py-12 px-6 md:px-12 border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_horological-craft/artifacts/n6ip39w0_logo1.jpg"
              alt="ART TIME Watches"
              className="h-12 w-auto mb-4"
            />
            <p className="font-sans text-sm text-[#A3A3A3] leading-relaxed">
              Curadoria exclusiva de relógios de luxo originais.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg text-white mb-4">Contato</h4>
            <div className="space-y-2 font-sans text-sm text-[#A3A3A3]">
              <p>WhatsApp: +55 44 99944-8428</p>
              <p>Email: arttimeamazon@gmail.com</p>
              <div className="flex gap-4 mt-4">
                <a
                  href="https://www.instagram.com/arttimewatches/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#C9A646] hover:text-white transition-colors"
                  data-testid="footer-instagram-store"
                >
                  <Instagram size={20} />
                </a>
                <a
                  href="https://www.instagram.com/andrerangel__/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#C9A646] hover:text-white transition-colors"
                  data-testid="footer-instagram-owner"
                >
                  <Instagram size={20} />
                </a>
              </div>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-serif text-lg text-white mb-4">Informações Legais</h4>
            <div className="space-y-2 font-sans text-sm text-[#A3A3A3]">
              <p>CNPJ: 64.514.802/0001-00</p>
              <p>Proprietário: André A. Rangel</p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 text-center">
          <p className="font-sans text-sm text-[#A3A3A3]">
            © {new Date().getFullYear()} ART TIME Watches. Todos os direitos reservados.
          </p>
          <p className="font-sans text-xs text-[#A3A3A3] mt-2">
            Trabalhamos exclusivamente com relógios de luxo originais.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
